import { Report } from '../../models/invoices/segments.report.model';
import { ActionTypes, ActionList } from '../../actions/invoices/actions-segments-report';

export interface State {
  errorMessage: string;
  updateRequired: boolean;
  data: Report;
}

/* eslint-disable */
export const initialState = {
  // do not update until config and options updated
  updateRequired: false,
  errorMessage: '',
  data: {} as Report
};

/* eslint-disable */
export function reducer(state = initialState, action: ActionList) {
  switch (action.type) {
    case ActionTypes.Update:
      return { ...state, updateRequired: true };
    case ActionTypes.Receive:
      return {
        data: action.payload.report,
        updateRequired: false,
        errorMessage: action.payload.errorMessage
      };
    case ActionTypes.Reset:
      return { ...initialState };
    default:
      return state;
  }
}
